import { createReducer, on } from '@ngrx/store';
import { studentActions } from '../actions/student.actions';
import { Student } from '../models';

export interface StudentEntry {
    loaded: boolean | null;
    loading: boolean;
    student: Student | null;
}

export interface StudentState {
    entries: Record<string, StudentEntry>;
    saved: boolean | null;
    saving: boolean;
}

export const initialState: StudentState = {
    entries: {},
    saved: null,
    saving: false,
};

export const studentReducer = createReducer(
    initialState,
    on(studentActions.getStudent, (state, { id }): StudentState => {
        if (state.entries[id]) {
            return state;
        }

        return {
            ...state,
            entries: {
                ...state.entries,
                [id]: { loaded: null, loading: true, student: null },
            },
        };
    }),
    on(
        studentActions.getStudentSuccess,
        (state, { payload }): StudentState => ({
            ...state,
            entries: {
                ...state.entries,
                [payload.id]: { loaded: true, loading: false, student: payload },
            },
        }),
    ),
    on(
        studentActions.getStudentError,
        (state, { id }): StudentState => ({
            ...state,
            entries: {
                ...state.entries,
                [id]: { loaded: false, loading: false, student: null },
            },
        }),
    ),
    on(
        studentActions.addStudent,
        (state): StudentState => ({
            ...state,
            saving: true,
            saved: null,
        }),
    ),
    on(
        studentActions.addStudentSuccess,
        (state): StudentState => ({
            ...state,
            saving: false,
            saved: true,
        }),
    ),
    on(
        studentActions.addStudentError,
        (state): StudentState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    on(studentActions.clear, (): StudentState => initialState),
);
